export const initialData = {
  nivel_autorizacao: 1,
  nomeclatura: '',
  obrigatoria: false,
  tipo_user_id: 3
}
export default initialData;
